import { Box, Button, styled } from '@mui/material';

export const ViewerContainer = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    minHeight: 600,
    position: 'relative',
}));

export const PDFContainer = styled(Box, {
    shouldForwardProp: (prop) =>
        prop !== 'useOriginalSize' && prop !== 'scrollPages',
})<{ useOriginalSize?: boolean; scrollPages?: boolean }>(
    ({ theme, useOriginalSize, scrollPages }) => ({
        flex: 1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        position: 'relative',
        zIndex: 1,
        background: theme.palette.grey[100],
        borderRadius: theme.shape.borderRadius,
        overflow: 'auto',
        width: '100%',
        height: '100%',

        '& .react-pdf__Document': {
            display: 'flex',
            flexDirection: scrollPages ? 'column' : 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            width: '100%',
            minHeight: '100%',
            gap: scrollPages ? theme.spacing(2) : 0,
            padding: scrollPages ? theme.spacing(2) : 0,
        },

        '& .react-pdf__Page': {
            width: '100% !important',
            maxWidth: '100%',
            maxHeight: useOriginalSize ? 'none' : '100%',
            margin: 0,
            display: 'flex',
            justifyContent: 'center',
        },

        '& .react-pdf__Page__canvas': {
            width: '100% !important',
            maxWidth: '100%',
            maxHeight: useOriginalSize ? 'none' : '100%',
            height: useOriginalSize ? 'auto !important' : 'auto !important',
        },
    })
);

export const NavigationControls = styled(Box)(() => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    pointerEvents: 'none',
}));

export const OverlayControls = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: 12,
    left: 12,
    display: 'flex',
    gap: theme.spacing(1),
    zIndex: 30,
    pointerEvents: 'auto',
}));

export const NavButton = styled(Button)<{ direction: 'left' | 'right' }>(
    ({ theme, direction }) => ({
        background: theme.palette.primary.light,
        borderRadius: direction === 'left' ? '0 20px 20px 0' : '20px 0 0 20px',
        minWidth: 20,
        width: 20,
        height: 40,
        padding: 0,
        pointerEvents: 'auto',
        color: theme.palette.common.white,
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        [direction]: 0,

        '&:hover': {
            background: theme.palette.primary.main,
        },

        '&.Mui-disabled': {
            opacity: 0.5,
        },
    })
);

export const ActionButton = styled(Button)(({ theme }) => ({
    background: 'rgba(128, 128, 128, 0.7)',
    minWidth: 40,
    width: 40,
    height: 40,
    padding: 0,
    borderRadius: '50%',
    color: theme.palette.common.white,
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.25)',

    '&:hover': {
        background: 'rgba(128, 128, 128, 0.9)',
    },
}));
